export const defaultErrorMessages: Record<number, string> = {
    400: "Bad Request. Please check the submitted data.",
    401: "Unauthorized. Please log in again.",
    403: "Forbidden. You don't have permission to access this resource.",
    404: "Not Found. The requested resource doesn't exist.",
    408: "Request Timeout. Please try again.",
    429: "Too many requests. Please slow down.",
    500: "Internal Server Error. Please try again later.",
    502: "Bad Gateway. Server is temporarily unavailable.",
    503: "Service Unavailable. Please try again later.",
    504: "Gateway Timeout. Server took too long to respond."
}; 